var SupportAPIHelper, SupportHelpWizardController, SupportTaglineHelper;

SupportAPIHelper = require('./helpers/API');

SupportTaglineHelper = require('./helpers/Tagline');

SupportHelpWizardController = {
  intermediatePage: function() {
    activateIntermediatePage();
    return Groupon.Support.HelpWizardViewManager.renderIntermediateView();
  },
  initOrdersFetch: function() {
    activateHelpWizard();
    Backbone.history.navigate("#pick-order", {
      trigger: false
    });
    setTrackingInformation("customer_support#pick-order", window.location.href);
    return Groupon.Support.HelpWizardViewManager.renderOrders();
  },
  stepOne: function(order) {
    activateHelpWizard();
    Backbone.history.navigate("#pick-order", {
      trigger: false
    });
    setTrackingInformation("customer_support#pick-order", window.location.href);
    return Groupon.Support.HelpWizardViewManager.renderOrderDetails(order);
  },
  abruptStepTwoFlow: function() {
    setDefaultSettingsForAbruptStepTwoFlow();
    return this.stepTwo();
  },
  stepTwo: function() {
    activateHelpWizard();
    setFlowAttributes();
    Backbone.history.navigate('#select-issue', {
      trigger: false
    });
    setTrackingInformation("customer_support#select-issue", window.location.href);
    Groupon.Support.Tagline = SupportTaglineHelper.create();
    Groupon.Support.HelpWizardViewManager.renderDropDowns();
    return Groupon.Support.ContentModel.onUnloadStepOne();
  },
  renderUserSignIn: function(options) {
    activateHelpWizard();
    return Groupon.Support.HelpWizardViewManager.renderUserSignIn(options);
  },
  stepThree: function() {
    var stepThreeView;
    activateHelpWizard();
    setTrackingInformation("customer_support#contact-us", window.location.href);
    return stepThreeView = Groupon.Support.HelpWizardViewManager.renderContactChannels();
  },
  problemSolved: function() {
    activateHelpWizard();
    setTrackingInformation("customer_support#problem-solved", window.location.href);
    return Groupon.Support.HelpWizardViewManager.renderProblemSolved();
  },
  ticketSuccess: function() {
    activateHelpWizard();
    setTrackingInformation("customer_support#ticket-success", window.location.href);
    return Groupon.Support.HelpWizardViewManager.ticketSuccess();
  },
  chatSuccess: function() {
    activateHelpWizard();
    setTrackingInformation("customer_support#chat-success", window.location.href);
    return Groupon.Support.HelpWizardViewManager.chatSuccess();
  },
  changeCurrentOrder: function(order) {
    Groupon.Support.currentOrder = order;
    return Groupon.Support.ContentModel.init(order);
  }
};

window.setFlowAttributes = function() {
  if (notLandingFlow()) {
    return;
  }
  if (window.landingFlow === "my_account") {
    return Groupon.Support.ACCOUNT_RELATED = true;
  } else if (window.landingFlow === "my_order") {
    return Groupon.Support.ABOUT_AN_ORDER = true;
  }
};

window.notLandingFlow = function() {
  return !window.landingFlow || oneOfFlowVariablesSet();
};

window.oneOfFlowVariablesSet = function() {
  return Groupon.Support.ACCOUNT_RELATED || Groupon.Support.ABOUT_AN_ORDER || Groupon.Support.SOMETHING_ELSE || Groupon.Support.PRE_PURCHASE;
};

window.setDefaultSettingsForAbruptStepTwoFlow = function() {
  Groupon.Support.MAXINDEX = 2;
  SupportHelpWizardController.changeCurrentOrder(null);
  Groupon.Support.ORDER_NOT_LISTED = false;
  if (window.isLoggedIn) {
    return Groupon.Support.NOT_ORDER_RELATED = true;
  }
};

window.activateHelpWizard = function() {
  $("#intermediate-page-container").hide();
  $('#contact-us-body-content').show();
  $('#footer-content').show();
  return showLoading($('#help-wizard'));
};

window.activateIntermediatePage = function() {
  $("#intermediate-page-container").show();
  $('#contact-us-body-content').hide();
  return $('#footer-content').hide();
};

module.exports = SupportHelpWizardController;

//# sourceMappingURL=data:application/json;base64,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
